import { TickerService } from "./TickerService";
export class CurrencyService {
  // private static DEFAULT_CURRENCY = "BTC";

  static async getSelected(): Promise<Currency | undefined> {
    const currency = window.fb_selected_currency;

    const tickerData = await TickerService.get();
    return tickerData.find((item) => item.code == currency);
  }
}
